import { Box, Table, Text } from '@factorialco/deprecated-design-system'

interface SummaryDescriptionCellProps {
  description: string
  secondaryDescription?: string
}

export const SummaryDescriptionCell = ({
  description,
  secondaryDescription,
}: SummaryDescriptionCellProps) => (
  <Table.Cell noBorder paddingX="s4" paddingY="s2">
    <Box height="s40" flexDirection="column" justifyContent="center">
      <Text.Normal ellipsis size="200">
        {description}
      </Text.Normal>
      {!!secondaryDescription && (
        <Text.Normal ellipsis size="100">
          {secondaryDescription}
        </Text.Normal>
      )}
    </Box>
  </Table.Cell>
)
